module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/check-d1240337f9cd38196a419f55bc00d4d3.png";